//
export default [
    {
        text: '#',
        value: 'id',
    },
    {
        text: 'responsable',
        value: 'g_originator_user_full_name',
    },
    {
        text: 'proveedor',
        value: 'pch_provider_alias_name',
        component: {
            custom: 'pch_provider_id',
            type: 'link',
            props: {
                mapper: value => ({
                    name: 'provider-update',
                    params: {
                        id: value,
                    },
                }),
                tooltip: 'Detalle proveedor',
            },
        },
    },
    {
        text: 'creación',
        value: 'created_at',
        format: 'datetime',
        align: 'right',
    },
    {
        text: 'autorización',
        value: 'authorization_date',
        format: 'datetime',
        align: 'right',
    },
    {
        text: 'estado',
        value: 'pch_purchase_order_state_name',
        align: 'center',
        component: {
            type: 'chip-label',
            props: {
                palette: {
                    cerrada: 'grey darken-4 white--text',
                    'cerrado_(precios_rectificados)': 'grey darken-4 white--text',
                    creada: 'accent lighten-3',
                    enviada: 'secondary lighten-3',
                    autorizada: 'success lighten-3',
                    cerrada_parcialmente: 'info lighten-3',
                    rechazada: 'error lighten-3',
                },
                noEvents: true,
                small: true,
            },
        },
        sortable: 'pch_purchase_order_state_id',
    },
    {
        text: 'total',
        value: 'total',
        format: 'currency',
        align: 'right',
    },
    {
        text: 'items',
        value: ({ pch_detail_purchase_orders }) =>
            pch_detail_purchase_orders.length,
        //format: "currency",
        align: 'right',
    },
]
